import { MutationApplicationCreateArgs } from 'generated/graphql';
import React from 'react';
import { NestDataObject } from 'react-hook-form';
import { InputField } from 'ui';

type Props = {
  register: any;
  errors: NestDataObject<MutationApplicationCreateArgs>;
};

const FormSectionApplicationDetails: React.FC<Props> = ({ register, errors }) => {
  return (
    <>
      <InputField
        name="name"
        placeholder="Name"
        showLabel
        ref={register({ required: true })}
        error={errors.name && 'Name required'}
      />
    </>
  );
};

export default FormSectionApplicationDetails;
